<template>
  <div id="app">
    <el-row :gutter="20">
      <router-view />
    </el-row>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      timer: false,
      screenWidth: document.body.clientWidth,
    };
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(() => {
          this.timer = false;
          if (
            navigator.userAgent.match(
              /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            )
          ) {
            // alert("手机端");
            this.$router.replace("/m");
            var whdef = 100 / 750; // 表示1920的设计图,使用100PX的默认值
            var rem = that.screenWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
            document.getElementsByTagName("html")[0].style.fontSize =
              rem + "px";
          } else {
            // alert("pc端");
            if (this.$route.path != "/") {
              this.$router.replace("/");
            }
            var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
            var rem = that.screenWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
            document.getElementsByTagName("html")[0].style.fontSize =
              rem + "px";
          }
        }, 400);
      }
    },
    // 页面自动定位到顶部
    $route: function (to, from) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },

  methods: {
    // isMobile() {
    //   let flag = navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   );
    //   return flag;
    // },
  },
};
</script>

<style lang="scss">
body::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 0;
}
@import "/style/common.scss";
.v-modal {
  z-index: 100 !important;
}
.el-popup-parent--hidden {
  padding-right: 0 !important;
}
.el-message {
  width: fit-content;
  min-width: 2rem;
  min-height: 0.56rem;
  top: 1rem !important;
}
.el-message .el-icon-warning,
.el-message__icon {
  font-size: 0.36rem;
}

html,
body {
  height: 100%;
}
body,
ul,
li,
a,
p,
div {
  /*慎删*/
  padding: 0px;
  margin: 0px;
}

ul,
li {
  list-style: none;
}
#app {
  font-family: PingFangSC-Regular, PingFang SC;
}
.redTextarea {
  .el-input__count {
    color: red !important;
  }
}
.el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.content12 {
  width: 12.5rem;
  max-width: 12.5rem;
  margin: 0 auto;
}
.moreEnglish {
  font-size: 0.24rem;
  font-weight: 500;
  color: #ff0009;
  cursor: pointer;
}
.marginTop50 {
  margin-top: 0.5rem;
}
.marginTop60 {
  margin-top: 0.6rem;
}
.marginTop100 {
  margin-top: 1rem;
}
.marginTop140 {
  margin-top: 1.4rem;
}
.imgTopText {
  width: fit-content;
  text-align: center;
  background: rgba(0, 1, 27, 0.4);
  position: absolute;
  font-size: 0.2rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  left: 0;
  bottom: 0;
  z-index: 1;
  cursor: pointer;
}
// 公共样式
.venueGreenText {
  color: rgba(255, 183, 1, 1);
}
/* 公共参评报名码开始 */
.font-size-20 {
  font-size: 0.2rem;
  font-weight: bold;
  color: #f9e9ec;
}
.font-size-14 {
  font-size: 0.14rem;
  font-weight: 400;
  color: #f9e9ec;
}
.sutpRightItemText {
  padding-right: 0.18rem;
  text-align: right;
}
.sutpRightItemTextTitle {
  padding-bottom: 0.12rem;
}
.sutpRightItemTextSubtitle {
  font-size: 0.16rem;
  font-weight: 400;
  color: rgb(255, 255, 255);
  letter-spacing: 0.07rem;
  // width: 1.5rem;
  text-align: center;
}
.sutpRightItemQrcode {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 0.04rem;
}
.sutpRightItemQrcode img {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 0.04rem;
  // padding-bottom: 0.16rem;
}
/* 公共参评报名码开始 */

/* 公共滚动条样式 */
.longPageScrollCont {
  padding: 0.4rem 0.2rem 0.36rem 0.4rem;
}
.pageScroll {
  height: 4.05rem;
  overflow-y: scroll;
}
.longPageScroll {
  height: 4.7rem;
  overflow-y: scroll;
  padding: 0 0.16rem 0 0;
}
.MpageScroll {
  height: 6.04rem;
  overflow-y: scroll;
}
.pageScroll::-webkit-scrollbar,
.longPageScroll::-webkit-scrollbar,
.MpageScroll::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0.04rem;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 0.04rem;
}

.pageScroll::-webkit-scrollbar-thumb,
.longPageScroll::-webkit-scrollbar-thumb,
.MpageScroll::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  width: 0.04rem;
  height: 0.8rem;
  background: #b61c22;
  border-radius: 0.02rem;
}

.pageScroll::-webkit-scrollbar-track,
.longPageScroll::-webkit-scrollbar-track,
.MpageScroll::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 0.05rem transparent;
  border-radius: 0;
  background: transparent;
}
/* 弹框关闭图标 */
.signUpDialogReturnPage {
  margin-right: 0.08rem;
  cursor: pointer;
  img {
    width: 0.2rem;
    height: 0.2rem;
  }
}
// 公共标题样式
.comTitlePadding {
  padding-left: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue